import React, { useState, InputHTMLAttributes, forwardRef } from 'react';
import * as styles from './DarkInput.css';

interface DarkInputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    errorMessage?: string;
    placeholder?: string;
}

export const DarkInput = forwardRef<HTMLInputElement, DarkInputProps>(
    ({ label, errorMessage, type = 'text', placeholder = '', ...props }, ref) => {
        const [isFocused, setIsFocused] = useState(false);
        const [hasValue, setHasValue] = useState(Boolean(props.value));

        const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
            setIsFocused(true);
            props.onFocus?.(e);
        };

        const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
            setIsFocused(false);
            props.onBlur?.(e);
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setHasValue(Boolean(e.target.value));
            props.onChange?.(e);
        };

        const showLabel = isFocused || hasValue;

        return (
            <div className={styles.container}>
                <div className={`${styles.inputContainer} ${errorMessage ? styles.error : ''}`}>
                    {label && (
                        <label
                            className={`${styles.label} ${showLabel ? styles.labelActive : styles.labelInactive}`}
                        >
                            {showLabel ? label : placeholder || label}
                        </label>
                    )}

                    <input
                        {...props}
                        ref={ref}
                        type={type}
                        className={styles.input}
                        placeholder={showLabel ? placeholder : ''}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                </div>

                {errorMessage && (
                    <div className={styles.errorMessage}>{errorMessage}</div>
                )}
            </div>
        );
    }
);

DarkInput.displayName = 'DarkInput'; 